import Layout from '@/layout';
export default {
  path: '/coupon',
  component: Layout,
  redirect: '/coupon/list',
  name: 'StoreCouponMenu',
  meta: {
    title: '营销',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/distribution/storeCoupon/index');
    },
    name: 'StoreCouponList',
    meta: {
      title: '优惠券'
    }
  }, {
    path: 'merCouponList',
    component: function component() {
      return import('@/views/distribution/storeCoupon/index');
    },
    name: 'StoreCouponLegacyList',
    meta: {
      title: '优惠券'
    }
  }]
};